// @flow

import variable from "./../variables/platform";

export default (variables /*: * */ = variable) => {
  const h2Theme = {
    color: variables.textColor,
    fontFamily: variables.TitleFont,
    fontSize: variables.fontSizeH2,
    lineHeight: variables.lineHeightH2,
  };

  return h2Theme;
};
